import React, { useEffect, useState, useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatepickerField from "../helpers/DatepickerField";
import { loadConfig } from "../helpers/config";
import LoadingSpinner from "../components/LoadingSpinner";
import { AuthContext } from "../helpers/AuthContext";


function AddTool() {
  let navigate = useNavigate();
  const { authState } = useContext(AuthContext);
  const initialValues = {
    serialnumber: "",
    dateofpurchase: "",
    ToolsGroupId: 1,
    storagePosition: "",
    owner: ""
  };

  const [ToolsGroupsObject, setToolsGroupsObject] = useState([]);
  const [ToolsObject, setToolsObject] = useState([]);
  const [apiUrl, setApiUrl] = useState("");
  const [loadingConfig, setLoadingConfig] = useState(true);

  useEffect(() => {
    async function fetchConfigAndGroups() {
      const config = await loadConfig();
      setApiUrl(config.APIURL);
      setLoadingConfig(false);
      const response = await axios.get(`${config.APIURL}/toolsgroups`, {
        headers: { accessToken: localStorage.getItem("accessToken") }
      });
      setToolsGroupsObject(response.data);
    }
    fetchConfigAndGroups();
  }, []);

  useEffect(() => {
    async function fetchTools() {
      if (!loadingConfig) {
        const response = await axios.get(`${apiUrl}/tools`, {
          headers: { accessToken: localStorage.getItem("accessToken") }
        });
        setToolsObject(response.data);
      }
    }
    fetchTools();
  }, [loadingConfig, apiUrl]);

  const validationSchema = Yup.object().shape({
    serialnumber: Yup.string().required("You must input a groupname!").notOneOf(ToolsObject.map(o => o.serialnumber), "Bereits vorhanden!"),
    dateofpurchase: Yup.date().required(),
    ToolsGroupId: Yup.number().required("Ungültige Gruppe!").oneOf(ToolsGroupsObject.map(option => option.id)),
    storagePosition: Yup.string().required("Lagerort ist erforderlich!"),
    owner: Yup.string()
  });

  const onSubmit = async (data) => {
    await axios.post(`${apiUrl}/tools`, data, {
      headers: { accessToken: localStorage.getItem("accessToken") }
    });
    navigate("/tools");
  };

  if (loadingConfig) {
    return <LoadingSpinner text="Lade Konfiguration..." />;
  }

  if (!authState.isAdmin) {
    return (
      <div className="container" style={{ marginTop: '100px', textAlign: 'center' }}>
        <h2>⚠️ Zugriff verweigert</h2>
        <p>Nur Administratoren können Geräte hinzufügen.</p>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <div className="card-header">Neues Gerät hinzufügen</div>
        <div className="card-body">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
          >
            <Form>
              <div className="form-group">
                <label htmlFor="serialnumber">Seriennummer:</label>
                <Field
                  id="serialnumber"
                  name="serialnumber"
                  placeholder="(Ex. C-Schlauch...)"
                  className="form-control"
                />
                <ErrorMessage name="serialnumber" component="span" className="error-message" />
              </div>

              <div className="form-group">
                <label htmlFor="dateofpurchase">Kaufdatum:</label>
                <Field
                  id="dateofpurchase"
                  name="dateofpurchase"
                  component={DatepickerField}
                  className="form-control"
                />
                <ErrorMessage name="dateofpurchase" component="span" className="error-message" />
              </div>

              <div className="form-group">
                <label htmlFor="ToolsGroupId">Gerätegruppe:</label>
                <Field
                  id="ToolsGroupId"
                  name="ToolsGroupId"
                  as="select"
                  className="form-control"
                >
                  {[...ToolsGroupsObject].sort((a, b) => a.groupname.localeCompare(b.groupname)).map((value, key) => (
                    <option key={key} value={`${value.id}`}>{value.groupname}</option>
                  ))}
                </Field>
                <ErrorMessage name="ToolsGroupId" component="span" className="error-message" />
              </div>

              <div className="form-group">
                <label htmlFor="storagePosition">Lagerort:</label>
                <Field name="storagePosition">
                  {({ field, form }) => {
                    // Find selected group
                    const selectedGroup = ToolsGroupsObject.find(g => g.id === Number(form.values.ToolsGroupId));
                    const optionsRaw = selectedGroup?.storagePositions;
                    let options = [];
                    if (typeof optionsRaw === "string") {
                      try {
                        options = JSON.parse(optionsRaw);
                      } catch {
                        options = [];
                      }
                    } else if (Array.isArray(optionsRaw)) {
                      options = optionsRaw;
                    }
                    return (
                      <select
                        id="storagePosition"
                        className="form-control"
                        {...field}
                      >
                        <option value="">Bitte wählen</option>
                        {[...options].sort((a, b) => a.localeCompare(b)).map((opt, idx) => (
                          <option key={idx} value={opt}>{opt}</option>
                        ))}
                      </select>
                    );
                  }}
                </Field>
                <ErrorMessage name="storagePosition" component="span" className="error-message" />
              </div>

              <div className="form-group">
                <label htmlFor="owner">Eigentümer:</label>
                <Field
                  id="owner"
                  name="owner"
                  placeholder="(Ex. Max Mustermann)"
                  className="form-control"
                />
                <ErrorMessage name="owner" component="span" className="error-message" />
              </div>

              <button type="submit" className="btn btn-primary">Hinzufügen</button>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default AddTool;
